import type React from "react";

export type ContributorAvatarSize = "sm" | "md" | "lg";

export interface ContributorAvatarProps {
  avatarUrl?: string | null;
  name: string;
  size?: ContributorAvatarSize;
  className?: string;
}

const sizeClasses: Record<ContributorAvatarSize, string> = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-16 h-16",
};

const textSizeClasses: Record<ContributorAvatarSize, string> = {
  sm: "max-sm:text-[0.9375rem] text-sm",
  md: "max-sm:text-[0.9375rem] text-sm",
  lg: "text-xl",
};

export const ContributorAvatar: React.FC<ContributorAvatarProps> = ({
  avatarUrl,
  name,
  size = "md",
  className = "",
}) => {
  const sizeClass = sizeClasses[size];
  const textClass = textSizeClasses[size];

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={`${sizeClass} rounded-full object-cover shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-primary flex items-center justify-center shrink-0 ${className}`}
    >
      <span
        className={`text-white ${textClass} font-bold`}
        style={{ fontFamily: "'Darumadrop One', sans-serif" }}
      >
        チョ
      </span>
    </div>
  );
};
